<template>  
  <div id="echart-box" :style="{width: '100%', height: '100%'}"></div>   
</template>

<script>

// import echarts from  "echarts/dist/echarts";

export default {
 
methods:{

  initChart(xData,yDataIn,yDataOut,yDataReal,serial) {

     
   
      let getchart = this.$echarts.init(document.getElementById('echart-box'));
      var  option = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: serial
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [{
          type: 'category',
          data: xData,
          axisLabel:{            
            rotate:-40,
          }
        }],
        yAxis: [{
          type:'value',
        }],
        series: [
          {
            name:serial[0],
            type: 'bar',
            bayGap: 0,
            data: yDataIn,
            emphasis:{focus:'series'},
            itemStyle: {
              color: 'orange',
              shadowColor: '#91cc75',
              borderType: 'dashed',
              opacity: 0.5
            }
          },
          {
            name:serial[1],
            type: 'bar',
            data: yDataOut,
            itemStyle: {
              color: 'blue',
              shadowColor: '#91cc75',
              borderType: 'dashed',
              opacity: 0.5
            }
          },
          {
            name:serial[2],
            type: 'bar',
            data: yDataReal,
            itemStyle: {
              color: 'green',
              shadowColor: '#91cc75',
              borderType: 'dashed',
              opacity: 0.5
            }
          }
        ]
      };
        

      getchart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        getchart.resize();
    });
  },

}

}
</script>


// WEBPACK FOOTER //
// src/components/boxGraph.vue